const root = "_uxsrc4kpny";

export { root };
import "./organism.root.style.linaria.module.css";
//# sourceMappingURL=organism.root.style.js.map
